import {
    Box,
    GridSlots,
    GridToolbarFilterButton,
    GridToolbarQuickFilter,
    Portal,
    PropsFromSlot,
} from '@thirdspacelearning/library';

const sx = {
    toolbarWrapper: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        rowGap: 2,
        columnGap: 1,
    },
    quickFilter: {
        width: '200px',
    },
    filterButton: {
        textTransform: 'none',
    },
};

const DataGridToolbar = ({
    setFilterButtonEl,
    filterPanelEl,
}: PropsFromSlot<GridSlots['toolbar']>) => {
    return (
        <Portal container={filterPanelEl.current}>
            <Box sx={sx.toolbarWrapper}>
                <GridToolbarQuickFilter
                    variant="outlined"
                    size="small"
                    sx={sx.quickFilter}
                    debounceMs={500}
                />
                <GridToolbarFilterButton
                    ref={setFilterButtonEl}
                    slotProps={{
                        button: { sx: sx.filterButton },
                    }}
                />
            </Box>
        </Portal>
    );
};

export default DataGridToolbar;
